/**
 * =============================================================================
 * Banner Switcher (배너 자동 전환)
 * =============================================================================
 * 
 * [역할]
 * URL Hash(#)에 따라 배너를 자동으로 전환합니다.
 * 
 * [동작]
 * - /account/login        → 로그인 배너 표시
 * - /account/login#recover → 비밀번호 찾기 배너 표시
 * - 링크 클릭 시 자동 전환
 * 
 * [사용법]
 * 1. 배너 요소에 data-banner-type 속성 추가
 * 2. URL이 #recover이면 recover 배너 표시, 아니면 login 배너 표시
 * 
 * [HTML 구조]
 * <div data-banner-type="login">로그인 배너</div>
 * <div data-banner-type="recover" class="hidden">복구 배너</div>
 * 
 * =============================================================================
 */

(function() {
  'use strict';

  // 배너 셀렉터
  const SELECTORS = {
    LOGIN: '[data-banner-type="login"]',
    RECOVER: '[data-banner-type="recover"]'
  };

  /**
   * URL Hash에 따라 배너를 전환합니다.
   */
  function switchBanner() {
    // 1. URL에 #recover 있는지 확인 (true/false)
    const isRecover = location.hash === '#recover';
    
    // 2. 배너 요소 찾기
    const loginBanner = document.querySelector(SELECTORS.LOGIN);
    const recoverBanner = document.querySelector(SELECTORS.RECOVER);

    // 3. #recover X → 로그인 배너 O, recover 배너 X
    //    #recover O → 로그인 배너 X, recover 배너 O
    if (loginBanner) {
      loginBanner.classList.toggle('hidden', isRecover);
      loginBanner.setAttribute('aria-hidden', isRecover);
    }
    if (recoverBanner) {
      recoverBanner.classList.toggle('hidden', !isRecover);
      recoverBanner.setAttribute('aria-hidden', !isRecover);
    }
  }

  // 초기 실행
  switchBanner();

  // URL Hash 변경 감지
  window.addEventListener('hashchange', switchBanner);

})();

